import { floatModulo, TradeType } from '@eih-netbroker/common';

export enum OrderPriceValidationError {
  Zero = 'zero',
  TooLow = 'too-low',
  TooHigh = 'too-high',
  TickSize = 'tick-size',
  StopWouldActivateImmediately = 'stop-would-activate-immediately',
}

type ValidateOrderPriceParams = {
  price: number;
  lowerLimitPrice: number;
  upperLimitPrice: number;
  tickSize?: number;
  tradeType?: TradeType;
  currentMarketPrice?: number;
};

export const validateOrderPrice = ({
  price,
  lowerLimitPrice,
  upperLimitPrice,
  tickSize,
  tradeType,
  currentMarketPrice,
}: ValidateOrderPriceParams): OrderPriceValidationError | undefined => {
  if (price === 0) {
    return OrderPriceValidationError.Zero;
  }
  if (price <= lowerLimitPrice) {
    return OrderPriceValidationError.TooLow;
  }
  if (price >= upperLimitPrice) {
    return OrderPriceValidationError.TooHigh;
  }
  if (tickSize === undefined) {
    return undefined;
  }
  if (floatModulo(price, tickSize) !== 0) {
    return OrderPriceValidationError.TickSize;
  }
  if (
    currentMarketPrice !== undefined &&
    ((tradeType === TradeType.Sell && price >= currentMarketPrice) ||
      (tradeType === TradeType.Buy && price <= currentMarketPrice))
  ) {
    return OrderPriceValidationError.StopWouldActivateImmediately;
  }

  return undefined;
};
